var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUltraportable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1421",
    "data-name": "Grupo 1421",
    transform: "translate(-504 -2654)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_112",
    "data-name": "Elipse 112",
    cx: 44.5,
    cy: 44,
    rx: 44.5,
    ry: 44,
    transform: "translate(504 2654)",
    fill: "rgba(0,170,255,0.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(512 2661)",
    fill: "#1de9b6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_941",
    "data-name": "Grupo 941",
    transform: "translate(525.744 2683.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_667",
    "data-name": "Trazado 667",
    d: "M191.517,47.221a.978.978,0,0,0,.757-.037,18.981,18.981,0,0,1,12.064-3.075c.674.032.9.393.709,1.059-.084.3-.2.583-.353,1.042.935-.468,1.687-.828,2.424-1.218a2.25,2.25,0,0,1,1.738-.217c1.815.5,3.646.936,5.459,1.438.395.11,1.015.181,1.112.6s-.534.795-.834,1.01c-.031.023-.621.444-.638.553.843-.17,2.363-.677,3.179-.793a2.343,2.343,0,0,1,1.219.084c1.889.843,3.8,1.656,5.607,2.66a21.34,21.34,0,0,1,3.8,2.7c1.037.925.836,1.645-.4,2.273a16.285,16.285,0,0,1-5.721,1.669,5.524,5.524,0,0,1-1.976-.212c-1.119-.3-2.209-.718-3.314-1.08a3.019,3.019,0,0,0-.413-.092.134.134,0,0,0-.153.1.138.138,0,0,0,.077.165l2.231.956a.529.529,0,0,1,.287.438c0,.137-.017.2-.257.37a33.084,33.084,0,0,1-7.229,1.179,2.245,2.245,0,0,1-1.9-.8c-.152-.172-.919-1.164-1.152-1.345l.541,1.325a.473.473,0,0,1-.467.458,1.752,1.752,0,0,1-.387-.033c-1.044-.23-2.1-.437-3.118-.748-3.953-1.2-7.79-2.674-10.936-5.532a4.6,4.6,0,0,1-1.915-3.842L186.007,46.3l.291-.887c1.793.625,3.5,1.232,5.218,1.807m14.592,8.333a.751.751,0,0,1,0-.425.464.464,0,0,1,.469-.367.685.685,0,0,1,.418.11c.883.763,1.728,1.573,2.569,2.386a1.6,1.6,0,0,0,1.353.565c1.671-.2,3.344-.369,5.017-.552l.056-.2c-.519-.4-1.063-.764-1.554-1.194-.416-.365-.985-.808-.705-1.408.3-.64.956-.3,1.44-.147,1.6.5,3.177,1.057,4.777,1.549a3.778,3.778,0,0,0,1.431.167,15.273,15.273,0,0,0,5.4-1.506.615.615,0,0,0,.135-1.089,23.8,23.8,0,0,0-5.388-3.347c-.942-.455-1.922-.828-2.857-1.3a3.052,3.052,0,0,0-2.52-.031,8.664,8.664,0,0,1-2.039.412c-.336.031-1.438.3-1.79-.263-.087-.139.121-.534.3-.705.352-.343.959-.608,1.445-.984a.073.073,0,0,0-.021-.126c-.369-.133-.829-.259-1.1-.328-1.373-.349-2.744-.726-4.132-1a2.723,2.723,0,0,0-1.448.188c-.816.323-1.568.816-2.385,1.138a1.454,1.454,0,0,1-.552.081.7.7,0,0,1-.692-.713,5.467,5.467,0,0,1,.03-.586,3.925,3.925,0,0,1,.314-.824,17.762,17.762,0,0,0-10.761,2.674,77.057,77.057,0,0,0,26.667,4.281c.018.32.033.6.052.938-9.451.358-18.51-1.529-27.523-4.348a3.72,3.72,0,0,0,1.48,2.737c2.929,2.658,6.48,4.083,10.154,5.242.874.275,1.768.477,2.654.71.186.092.2-.109.138-.183a15.123,15.123,0,0,1-.828-1.55",
    transform: "translate(-185.353 -29.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_668",
    "data-name": "Trazado 668",
    d: "M193.315,36.613c0,1.807-1.3,3.382-4.153,3.382a6.8,6.8,0,0,1-3.811-1.093l.914-1.808a4.739,4.739,0,0,0,2.841.919c1.156,0,1.869-.495,1.869-1.327,0-.8-.514-1.327-2.326-1.327h-2.555l.515-5.743H192.7v1.9h-4.168l-.157,1.939h.814c2.953,0,4.124,1.355,4.124,3.163",
    transform: "translate(-185.351 -29.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_669",
    "data-name": "Trazado 669",
    d: "M194.279,34.717c0-3.367,1.827-5.277,4.281-5.277,2.47,0,4.282,1.91,4.282,5.277s-1.812,5.276-4.282,5.276c-2.454,0-4.281-1.91-4.281-5.276m6.237,0c0-2.318-.8-3.279-1.956-3.279s-1.94.962-1.94,3.279.8,3.279,1.94,3.279,1.956-.961,1.956-3.279",
    transform: "translate(-185.374 -29.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_670",
    "data-name": "Trazado 670",
    d: "M203.994,34.717c0-3.367,1.827-5.277,4.281-5.277,2.47,0,4.282,1.91,4.282,5.277s-1.812,5.276-4.282,5.276c-2.454,0-4.281-1.91-4.281-5.276m6.237,0c0-2.318-.8-3.279-1.956-3.279s-1.94.962-1.94,3.279.8,3.279,1.94,3.279,1.956-.961,1.956-3.279",
    transform: "translate(-185.399 -29.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_671",
    "data-name": "Trazado 671",
    d: "M222.1,31.984v6.53c0,2.915-1.54,4.256-4.309,4.256a6.231,6.231,0,0,1-3.768-1.078l.885-1.633a4.522,4.522,0,0,0,2.712.89c1.57,0,2.255-.729,2.255-2.143V38.47a3.127,3.127,0,0,1-2.426.976,3.79,3.79,0,1,1,0-7.579,3.055,3.055,0,0,1,2.539,1.122V31.984Zm-2.2,3.673a2.022,2.022,0,1,0-2.012,1.924,1.882,1.882,0,0,0,2.012-1.924",
    transform: "translate(-185.424 -29.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_672",
    "data-name": "Trazado 672",
    d: "M228.963,31.866v2.1c-.186-.014-.328-.028-.5-.028a1.908,1.908,0,0,0-2.041,2.186v3.7H224.2V31.983h2.126v1.035a3.069,3.069,0,0,1,2.64-1.152",
    transform: "translate(-185.451 -29.446)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUltraportable);
export default __webpack_public_path__ + "static/media/ic_ultraportable.a56779ad01da0b8b26862dbaf5dd79f9.svg";
export { ForwardRef as ReactComponent };